import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { ByteArray } from '../utils/ByteArray';
import { Event } from '../events/Event';
import { Settings } from '../Settings';
var USE_FILE_PICKER = ('showSaveFilePicker' in self) && Settings.ENABLE_FILE_PICKER;
if (USE_FILE_PICKER) {
    console.debug('[FileReference] `showSaveFilePicker` used for save()');
}
var FileReference = /** @class */ (function (_super) {
    __extends(FileReference, _super);
    function FileReference() {
        return _super.call(this) || this;
    }
    Object.defineProperty(FileReference.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (value) {
            this._size = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "extension", {
        get: function () {
            return this._extension;
        },
        set: function (value) {
            this._extension = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "permissionStatus", {
        get: function () {
            return this._permissionStatus;
        },
        set: function (value) {
            this._permissionStatus = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "creator", {
        get: function () {
            return this._creator;
        },
        set: function (value) {
            this._creator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "modificationDate", {
        get: function () {
            return this._modificationDate;
        },
        set: function (value) {
            this._modificationDate = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileReference.prototype, "creationDate", {
        get: function () {
            return this._creationDate;
        },
        set: function (value) {
            this._creationDate = value;
        },
        enumerable: false,
        configurable: true
    });
    //Displays a file-browsing dialog box that lets the user select a file to upload.
    FileReference.prototype.browse = function (typelist) {
        var _a;
        var _this = this;
        var knownTypes = FileReference.knownMimeTypes;
        var openDialog = window.showOpenFilePicker;
        if (!openDialog) {
            console.warn('[flash/net/FileReference] FileSystem API not supported!');
            return false;
        }
        var types = [];
        for (var i = 0; i < typelist.length; i++) {
            var filter = typelist[i];
            var extension = filter.extension.slice(filter.extension.lastIndexOf('.'));
            var mime = extension in knownTypes ? knownTypes[extension]['mime'] : 'application/unknown';
            types.push({
                description: filter.description,
                accept: (_a = {}, _a[mime] = extension, _a)
            });
        }
        var options = {
            types: types
        };
        openDialog(options)
            .then(function (fileHandler) {
            _this._sendSelectEvent();
            return fileHandler[0].getFile();
        })
            .then(function (file) {
            _this.modificationDate = new Date(file.lastModified);
            _this.name = file.name;
            _this.size = file.size;
            _this.type = file.type;
            var extIndex = file.name.lastIndexOf('.');
            _this.extension = extIndex >= 0 ? file.name.slice(extIndex + 1) : null;
            return file.arrayBuffer();
        })
            .then(function (buf) {
            _this.data = new ByteArray(buf.byteLength);
            _this.data.setArrayBuffer(buf);
            _this._sendCompleteEvent();
        })
            .catch(function (e) {
            if (e.code === 20 && e.message === 'The user aborted a request.') {
                _this._sendCancelEvent();
                return;
            }
            console.warn('[flash/net/FileReference] FileSystem API Reject `showOpenFilePicker` request:', e);
        });
        return true;
    };
    //Starts the upload of the file to a remote server.
    FileReference.prototype.upload = function (url) {
        console.log('upload not implemented yet in flash/FileReference');
        return true;
    };
    //Starts the load of a local file selected by a user.
    FileReference.prototype.load = function () {
        console.log('load not implemented yet in flash/FileReference');
    };
    //Opens a dialog box that lets the user save a file to the local filesystem.
    FileReference.prototype.save = function (data, _defaultFileName) {
        if (_defaultFileName === void 0) { _defaultFileName = null; }
        if (this._useFileSystemSave(data, _defaultFileName)) {
            return;
        }
    };
    FileReference.prototype._useFileSystemSave = function (data, name) {
        var _a;
        var _this = this;
        if (name === void 0) { name = ''; }
        var knownTypes = FileReference.knownMimeTypes;
        var isString = typeof data === 'string';
        var isByteArray = data.getBytes !== undefined;
        var ext = name.slice(name.lastIndexOf('.'));
        if (!USE_FILE_PICKER)
            return false;
        // this is draft API
        // https://web.dev/file-system-access/
        var openDialog = window.showSaveFilePicker;
        if (!openDialog) {
            console.warn('[flash/net/FileReference] FileSystem API not supported!');
            return false;
        }
        if (!isString && !isByteArray) {
            console.warn('[FileReference] Save is only supported for String and ByteArray');
            return;
        }
        var types = [];
        if (ext in knownTypes) {
            var mime = knownTypes[ext].mime;
            types[0] = {
                description: knownTypes[ext].description,
                accept: (_a = {}, _a[mime] = ext, _a),
            };
        }
        else {
            types[0] = {
                description: '',
                accept: { 'application/unknown': ext },
            };
        }
        var options = {
            suggestedName: name || '',
            types: types
        };
        openDialog(options)
            .then(function (fileHandler) {
            _this._sendSelectEvent();
            return fileHandler.createWritable();
        })
            .then(function (stream) {
            return stream
                .write(isByteArray ? data.getBytes() : data)
                .then(function () { return stream.close(); });
        })
            .then(function (_e) {
            _this._sendCompleteEvent();
        })
            .catch(function (e) {
            if (e.code === 20 && e.message === 'The user aborted a request.') {
                _this._sendCancelEvent();
                return;
            }
            console.warn('[flash/net/FileReference] FileSystem API Reject `showSaveFilePicker` request:', e);
        });
    };
    FileReference.prototype._sendCancelEvent = function () {
        var event = new this.sec.flash.events.Event(Event.CANCEL);
        event.currentTarget = this;
        event.target = this;
        this.dispatchEvent(event);
    };
    FileReference.prototype._sendCompleteEvent = function () {
        var event = new this.sec.flash.events.Event(Event.COMPLETE);
        event.currentTarget = this;
        event.target = this;
        this.dispatchEvent(event);
    };
    FileReference.prototype._sendSelectEvent = function () {
        var event = new this.sec.flash.events.Event(Event.SELECT);
        event.currentTarget = this;
        event.target = this;
        this.dispatchEvent(event);
    };
    //Requests permission to access filesystem.
    FileReference.prototype.requestPermission = function () {
        console.log('upload not implemented yet in flash/FileReference');
    };
    //Opens a dialog box that lets the user download a file from a remote server.
    FileReference.prototype.download = function (url, defaultFileName) {
        console.log('download not implemented yet in flash/FileReference');
        return true;
    };
    //Cancels any ongoing upload or download operation on this FileReference object.
    FileReference.prototype.cancel = function () {
        console.log('cancel not implemented yet in flash/FileReference');
    };
    FileReference.forceNativeMethods = true;
    FileReference.knownMimeTypes = {
        '.jpeg': { 'mime': 'image/jpeg', 'description': 'JPEG images' },
        '.jpg': { 'mime': 'image/jpeg', 'description': 'JPEG images' },
        '.txt': { 'mime': 'text/plain', 'description': 'Text documents' },
    };
    return FileReference;
}(EventDispatcher));
export { FileReference };
